import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedVideos() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选全网最热视频，不容错过</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {featuredVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              slug={video.slug}
              thumbnail={video.thumbnail}
              duration={video.duration}
              category={video.category}
              categorySlug={video.categorySlug}
              views={video.views}
              rating={video.rating}
              isHot={video.isHot}
              isNew={video.isNew}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}